/*
 * Copyright (c) CIRROM 2025.
 */

import React, { JSX } from "react";
import { matchPath } from "react-router-dom";

import SidebarNavList from "./SidebarNavList";
import { SidebarItemsType } from "../../types/sidebar";
import { SidebarNavListItem } from "./SidebarNavListItem";

// Default icon to avoid creating new function instances on every render
const DefaultIcon: React.FC = () => null;

type ReduceChildRoutesProps = {
  depth: number;
  page: SidebarItemsType;
  items: JSX.Element[];
  currentRoute: string;
  isCollapsed?: boolean;
};

export const reduceChildRoutes = (props: ReduceChildRoutesProps) => {
  const { items, page, depth, currentRoute, isCollapsed = false } = props;

  if (page.children) {
    const open = page.href
      ? !!matchPath(
          {
            path: page.href,
            end: false,
          },
          currentRoute
        )
      : false;

    items.push(
      <SidebarNavListItem
        depth={depth}
        icon={page.icon || DefaultIcon}
        key={page.title}
        badge={page.badge}
        open={!!open}
        title={page.title}
        href={page.href}
        isCollapsed={isCollapsed}
        collapsedHref={page.collapsedHref}
        hideWhenCollapsed={page.hideWhenCollapsed}
      >
        <SidebarNavList
          depth={depth + 1}
          pages={page.children}
          isCollapsed={isCollapsed}
        />
      </SidebarNavListItem>
    );
  } else {
    items.push(
      <SidebarNavListItem
        depth={depth}
        href={page.href}
        icon={page.icon || DefaultIcon}
        key={page.title}
        badge={page.badge}
        title={page.title}
        isCollapsed={isCollapsed}
      />
    );
  }

  return items;
};
